module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showCounter) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('div', {
    staticClass: "edo-progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: 100 - _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "edo-tree-icon",
    style: ({
      left: 'calc(' + _vm.progress + '% - 32px)'
    })
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3519/dist/assets/img/edo-tree-icon.svg"
    }
  })])]), _vm._v(" "), (_vm.showCounter) ? _c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.currentCounter,
      "autoplay": false,
      "duration": 7000
    },
    on: {
      "callbackCounter": _vm.updatePercentage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "form-scroll-to"
    }
  }, [_vm._v(_vm._s(_vm.counterTitle))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [(_vm.intro) ? _c('p', {
    staticClass: "form-intro"
  }, [_vm._v(_vm._s(_vm.intro))]) : _vm._e(), _vm._v(" "), (_vm.viewMessagePosition === 'top') ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": _vm.viewMessageButtonValue
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('firstName')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("firstName")))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('lastName')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("lastName")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionEmailIsValid: true,
        email: true,
      }),
      expression: "{\n              required: true,\n              petitionEmailIsValid: true,\n              email: true,\n            }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3519/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("email")))]) : _vm._e()])]), _vm._v(" "), ((_vm.country == 'Australia' ? 'number' : 'text') === 'checkbox' && (_vm.showPostcode)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true,
        length: _vm.country == 'Australia' ? 4 : false
      }),
      expression: "{ required: true, alpha_num: true, length: country == 'Australia' ? 4 : false }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postcode) ? _vm._i(_vm.postcode, null) > -1 : (_vm.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postcode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postcode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postcode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postcode = $$c
        }
      }
    }
  }) : ((_vm.country == 'Australia' ? 'number' : 'text') === 'radio' && (_vm.showPostcode)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true,
        length: _vm.country == 'Australia' ? 4 : false
      }),
      expression: "{ required: true, alpha_num: true, length: country == 'Australia' ? 4 : false }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postcode, null)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postcode = null
      }
    }
  }) : (_vm.showPostcode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_num: true,
        length: _vm.country == 'Australia' ? 4 : false
      }),
      expression: "{ required: true, alpha_num: true, length: country == 'Australia' ? 4 : false }"
    }],
    class: {
      'border-red': _vm.errors.has('postcode')
    },
    attrs: {
      "name": "postcode",
      "placeholder": "Postcode",
      "type": _vm.country == 'Australia' ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('postcode')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("postcode")))]) : _vm._e()]), _vm._v(" "), (_vm.showPhoneNumber) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.isPhoneMandatory,
        petitionPhoneNumberIsValid: true,
      }),
      expression: "{\n            required: isPhoneMandatory,\n            petitionPhoneNumberIsValid: true,\n          }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phoneNumber')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first("phoneNumber")))]) : _vm._e()]), _vm._v(" "), (_vm.showState) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "placeholder": "State"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outside Australia"
    }
  }, [_vm._v("Outside Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showCountry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('country')
    },
    attrs: {
      "name": "country",
      "autocomplete": "country",
      "placeholder": "Country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v("\n            " + _vm._s(countries.name) + "\n          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.showMessage) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": "Your message. Writing a personalised message makes it harder for our politicians to ignore",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('message')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMessage) ? _c('p', {
    staticClass: "word-count"
  }, [_vm._v("\n          " + _vm._s(255 - (_vm.message ? _vm.message.length : 0) + " Char") + "\n        ")]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "value": _vm.isSaving ? 'Loading...' : _vm.signButtonValue
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), (_vm.viewMessagePosition === 'bottom') ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": _vm.viewMessageButtonValue
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPure),
      expression: "!isPure"
    }],
    staticClass: "alert-box"
  }, [_vm._v("\n          No bad words! Please change your message.\n        ")]), _vm._v(" "), _vm._m(0, false, false)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("\n            By signing you accept\n            "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("\n              WWF-Australia’s Privacy Policy.\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71255a36","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=csplt5ikear!./~/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./src/components/forms/PetitionBio.vue
// module id = 696
// module chunks = 0